import { useCallback, useEffect, useState } from "react";
import {
  CommonHeader,
  EmptyListPage,
  ErrorSuccessModal,
  TableLoader,
} from "../../../components/commons";
import { RootState } from "../../../redux/rootReducers";
import toast, { Toaster } from "react-hot-toast";
import { connect } from "react-redux";
import { resetSession } from "../../../redux/auth";
import {
  checkUniqueClientGroupNameAction,
  createMasterDataClientCategoryAction,
  getMasterDataClientCategoryAction,
  resetClientCategoryList,
  resetClientCategoryTotalCount,
  resetClientGroupUniqueCheckFetching,
  resetClientGroupUniqueCheckMessage,
  resetMasterError,
  resetMasterMessage,
  resetMasterStatusCode,
  resetMasterSuccess,
  updateMasterDataClientCategoryAction,
} from "../../../redux/masterData";
import { EmptyList } from "../../../assets/images";
import ClientCategoryTable from "../../../components/MasterData/ClientCategoryTable/ClientCategoryTable";
import AddEditClientCategory from "../../../components/MasterData/ClientCategoryTable/AddEditClientCategory";
import { ClientCategoryListType } from "../../../redux/masterData/masterTypes";
import {
  AddClientCategoryPayloadType,
  GetClientCategoryPayloadType,
  UniqueClientGroupNamePayloadType,
  UpdateClientCategoryPayloadType,
} from "../../../commonTypes/masterDataTypes";
import { SearchIcon } from "../../../components/Icon";
import useDebounce from "../../../customHooks/useDebounce";
import MultiSelect from "../../../components/commons/MultiSelect";
import ClientCategoryFilter, { CATEGORY_STATUS_RADIO_OPTIONS } from "../../../components/MasterData/ClientCategoryTable/ClientCategoryFilter";
import { RadioTypes } from "../../../commonTypes/universalTypes";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";

type AppProps = {
  history: any;
  fetching: boolean;
  message: string;
  success: null | number;
  error: null | string;
  statusCode: null | number;
  isOpen: boolean;
  token: null | string;
  clientCategoryList: ClientCategoryListType[] | [];
  clientCategoryTotalCount: number;
  clientGroupUniqueCheckMessage: string;
  uniqueClientFetching: boolean;
  dispatchResetMasterStatusCode: () => void;
  dispatchResetSession: () => void;
  dispatchResetClientCategoryList: () => void;
  rdispatchResetClientCategoryTotalCount: () => void;
  dispatchResetMasterSuccess: () => void;
  dispatchResetMasterMessage: () => void;
  dispatchResetMasterError: () => void;
  dispatchGetMasterDataClientCategoryAction: (
    data: GetClientCategoryPayloadType
  ) => void;
  dispatchAddMasterDataClientCategoryAction: (
    data: AddClientCategoryPayloadType
  ) => void;
  dispatchUpdateMasterDataClientCategoryAction: (
    data: UpdateClientCategoryPayloadType
  ) => void;
  dispatchResetClientGroupUniqueCheckMessage: () => void;
  dispatchResetresetClientGroupUniqueCheckFetching: () => void;
  dispatchCheckUniqueClientGroupName: (data: UniqueClientGroupNamePayloadType) => void
};
const ClientCategory = ({
  fetching,
  message,
  success,
  error,
  token,
  statusCode,
  dispatchResetMasterError,
  dispatchResetClientCategoryList,
  dispatchResetSession,
  rdispatchResetClientCategoryTotalCount,
  dispatchResetMasterSuccess,
  dispatchResetMasterMessage,
  dispatchResetMasterStatusCode,
  clientCategoryList,
  clientCategoryTotalCount,
  clientGroupUniqueCheckMessage,
  uniqueClientFetching,
  dispatchGetMasterDataClientCategoryAction,
  dispatchAddMasterDataClientCategoryAction,
  dispatchUpdateMasterDataClientCategoryAction,
  dispatchResetClientGroupUniqueCheckMessage,
  dispatchResetresetClientGroupUniqueCheckFetching,
  dispatchCheckUniqueClientGroupName,
}: AppProps) => {
  const [showAddEditClientCategoryModal, setShowAddEditClientCategoryModal] =
    useState<boolean>(false);
  const [successMessage, setSuccessMessage] = useState<string>("");
  const [clientCategoryNameError, setClientCategoryNameError] =
    useState<string>("");
  const [clientCategoryName, setClientCategoryName] = useState<string>("");
  const [data, setData] = useState<[] | ClientCategoryListType[]>([]);
  const [refresh, setRefresh] = useState<boolean>(false);
  const [isEdit, setIsEdit] = useState<boolean>(false);
  const [id, setId] = useState<string | null | undefined>(null);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [status, setStatus] = useState(true);
  const [searchValue, setSearchValue] = useState("");

  // filter
  const [activeStatus, setActiveStatus] = useState("");
  const [activeStatusValue, setActiveStatusValue] = useState<string>("");
  const [isMultiSelectPresent, setIsMultiSelectPresent] =
  useState<boolean>(false);
const [multiSelectData, setMultiSelectData] = useState<any>([]);
const [clearFilter, setClearFilter] = useState<boolean>(false);

  //====================User Management=============================
  const [isAddClientCategoryPresent, setIsAddClientCategoryPresent] =
    useMenuCheck();
  const [isEditClientCategoryPresent, setIsEditClientCategoryPresent] =
    useMenuCheck();
  //=================================================================

  useEffect(() => {
    dispatchResetMasterSuccess();
    dispatchResetMasterError();
    dispatchResetMasterMessage();
    dispatchResetClientCategoryList();
    rdispatchResetClientCategoryTotalCount();
    dispatchResetMasterStatusCode();
    setIsAddClientCategoryPresent("Add Client Category", "menu");
    setIsEditClientCategoryPresent("Edit Client Category", "menu");
  }, []);

  useEffect(() => {
    if (clientCategoryList?.length === 0) {
      setData(clientCategoryList);
    }
    if (offset > 0) {
      setData((prv: any) => [...prv, ...clientCategoryList]);
    } else {
      setData(clientCategoryList);
    }
  }, [clientCategoryList]);

  useEffect(() => {
    setIsMultiSelectPresent(false);
  }, []);

  useEffect(() => {
    if (token) {
      let finalData: GetClientCategoryPayloadType = {
        token,
        limit,
        offset,
        search_term: searchValue,
        status: activeStatus
      };
      if(clearFilter){
        finalData.status="";
        setActiveStatus("");
        setActiveStatusValue("");
        setClearFilter(false)
      }
      if (clientCategoryTotalCount) {
        if (offset < clientCategoryTotalCount) {
          dispatchGetMasterDataClientCategoryAction(finalData);
        }
      } else {
        dispatchGetMasterDataClientCategoryAction(finalData);
      }
    }
  }, [offset , clearFilter]);

  useEffect(() => {
    if (!showAddEditClientCategoryModal) {
      setIsEdit(false);
    }
  }, [showAddEditClientCategoryModal]);

  useDebounce(
    () => {
      if (searchValue) {
        fetchNewData();
      } else {
        let finalData: GetClientCategoryPayloadType = {
          token,
          limit,
          offset,
          search_term: searchValue,
          status :activeStatus
        };
        dispatchGetMasterDataClientCategoryAction(finalData);
      }
    },
    500,
    [searchValue]
  );

  const fetchNewData = () => {
    dispatchResetClientCategoryList();
    if (token) {
      let finalData = {
        token,
        search_term: searchValue,
        limit,
        offset,
        status:activeStatus
      };
      if (offset === 0) {
        dispatchGetMasterDataClientCategoryAction(finalData);
      } else {
        setOffset(0);
      }
    }
  };

  const handleToogleStatusChange = () => {
    if (isEdit) {
      setStatus(!status);
    } else {
      setStatus(true);
    }
  };
  const handleClientCategoryNameChange = (e: any) => {
    setClientCategoryName(e.target.value);
  };

  const toggleAddEditClientCategoryModal = () => {
    if (!showAddEditClientCategoryModal) {
      handleResetData();
    }

    setShowAddEditClientCategoryModal(!showAddEditClientCategoryModal);
  };

  const handleResetData = () => {
    setClientCategoryName("");
    setOffset(0);
  };

  const handleEditMasterClientCategory = (data: any) => {
    setIsEdit(true);
    setShowAddEditClientCategoryModal(true);
    setClientCategoryName(data?.name_of_category);
    setStatus(data?.status);
    setId(data?._id);
  };

  const handleSearch = (e: any) => {
    let value = e.target.value;
    setSearchValue(value);

    if (value?.length === 0) {
      let finalData = {
        offset: 0,
        limit,
        token,
        status :activeStatus

      };
      dispatchGetMasterDataClientCategoryAction(finalData);
    }
  };

  const handleAddClientCategory = () => {
    setRefresh(!refresh);
    dispatchResetClientCategoryList();
    dispatchResetMasterStatusCode();
    dispatchResetClientGroupUniqueCheckMessage();
    dispatchResetresetClientGroupUniqueCheckFetching();
    if (clientCategoryName?.trim()?.length > 0) {
      if (isEdit) {
      let updateData = {
        token: token,
        name_of_category: clientCategoryName?.trim(),
        status: status,
        _id: id,
      };
      dispatchUpdateMasterDataClientCategoryAction(updateData);
      handleSuccessMessage("update-master-client-category");
    } else {
      let finalAddData = {
        token,
        name_of_category: clientCategoryName?.trim(),
      };
      setClearFilter(true)
      dispatchAddMasterDataClientCategoryAction(finalAddData);
      handleSuccessMessage("created-master-client-category");
      setSearchValue("");
    }
  }

    let finalData = {
      token,
      limit,
      offset,
      search_term: searchValue,
      status:activeStatus



    };
    if (offset === 0) {
      dispatchGetMasterDataClientCategoryAction(finalData);
    } else {
      setOffset(0);
    }
  };


  useDebounce(
    () => {
        if (clientCategoryName?.trim() && token) {
            const finalData = {
                token,
                operation: isEdit ? "update" : "add",
                uniqueCheck: "client_category",
                name: clientCategoryName?clientCategoryName.trim():"",
                dataId: isEdit ? id : ""
            }
            dispatchCheckUniqueClientGroupName(finalData);
        }
    },
    500,
    [clientCategoryName]
)

  const handleSuccessMessage = (type: string) => {
    switch (type) {
      case "created-master-client-category":
        return setSuccessMessage("Client Category Added Successfully!");
      case "update-master-client-category":
        return setSuccessMessage("Client Category Updated Successfully!");
      default:
        return setSuccessMessage("");
    }
  };

  useEffect(() => {
    dispatchResetClientCategoryList();
    rdispatchResetClientCategoryTotalCount()
    getData();
    setOffset(0);
    setIsMultiSelectPresent(true);
    if (
      (activeStatus && isMultiSelectPresent) ||
      (!activeStatus && isMultiSelectPresent)
    ) {
      if (offset === 0&&token) {

        let finalData = {
          token,
          limit,
          offset,
          search_term: searchValue,
          status:activeStatus
        };
        dispatchGetMasterDataClientCategoryAction(finalData);
      }
    }
  }, [activeStatus]);

  const getData = useCallback(() => {
    const getCategoryStatusValue = CATEGORY_STATUS_RADIO_OPTIONS.find(
      (item: RadioTypes) => String(item.id) === String(activeStatus)
    );
    setMultiSelectData([getCategoryStatusValue]);
  }, [activeStatus]);

  const onScroll = () => {
    if (!fetching) {
      const scrollTop = document.documentElement.scrollTop;
      const scrollHeight = document.documentElement.scrollHeight;
      const clientHeight = document.documentElement.clientHeight;

      if (
        offset < clientCategoryTotalCount &&
        !fetching &&
        Math.ceil((75 / 100) * scrollHeight) <= scrollTop + clientHeight
      ) {
        if (clientCategoryList?.length > 0) {
          if (!fetching && offset < clientCategoryTotalCount) {
            setOffset(offset + limit);
          }
        }
      }
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [clientCategoryList]);

  const onClose = (id: any) => {
    
    const checkActiveStatusValue = CATEGORY_STATUS_RADIO_OPTIONS.find(
      (item: RadioTypes) => item._id == id
    );
    if (checkActiveStatusValue) {
      setActiveStatus("");
      setActiveStatusValue("");
    }
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } 
     
      else if (
        success === 0 &&
        (error?.includes("Cannot Disable! Client category mapped to Clients.") ||
          error?.includes("Cannot Disable! Client category mapped to Clients."))
      ) {
        dispatchResetClientCategoryList();
        dispatchResetMasterSuccess();
        dispatchResetMasterMessage();
        dispatchResetMasterError();
        toast.error(
          error?.includes("Cannot Disable! Client category mapped to Clients.")
            ? "Cannot Disable! Client category mapped to Clients."
            : "Cannot Disable! Client category mapped to Clients.",
          {
            duration: 2000,
          }
        );
        let finalData = {
          token,
          limit,
          offset: 0,
          search_term: searchValue,
          status:activeStatus
        };
        if (offset === 0) {
          dispatchGetMasterDataClientCategoryAction(finalData);
        }
      }
      else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetMasterError();
            }}
          />
        );
      }
    }
    if (success === 1 && message?.includes("added successfully!")) {
      dispatchResetClientCategoryList();
      dispatchResetMasterSuccess();
      dispatchResetMasterMessage();
      toast.success(successMessage, {
        duration: 2000,
      });
      if (token) {
        let finalData = {
          token,
          limit,
          offset: 0,
          search_term: searchValue,
          status:activeStatus

        };
        if (offset === 0) {
          dispatchGetMasterDataClientCategoryAction(finalData);
        } else {
          setOffset(0);
        }
      }
    }
    if (success === 1 && message?.includes("updated successfully!")) {
      dispatchResetClientCategoryList();
      dispatchResetMasterSuccess();
      dispatchResetMasterMessage();
      toast.success(successMessage, {
        duration: 2000,
      });
  
      if (token) {
        let finalData = {
          token,
          limit,
          offset: 0,
          search_term: searchValue,
          status:activeStatus

        };
        if (offset === 0) {
          dispatchGetMasterDataClientCategoryAction(finalData);
        }
      }
    }

    return false;
  };

  useEffect(() => {
    if (offset === 0) {
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(0, 0);
      setOffset(0);
    }
  }, [success]);


  return (
    <div className="row">
      <div className="col-md-6">
        <CommonHeader title="Client Category" />
      </div>
      <div className="col-md-12">
        <div className="jobs-card">
          <div className="header">
            <div className="left-header">
              <div className="heading">Client Category List</div>
              {!fetching && (
                <div
                  className="sub-heading"
                  style={{ marginTop: "-22px" }}
                >{`Total ${
                  clientCategoryTotalCount ? clientCategoryTotalCount : 0
                } categories found`}</div>
              )}
            <div> <MultiSelect data={multiSelectData} onClose={onClose} /></div>


            </div>
            <div className="right-header">
              <div
                className={`${
                  !!clientCategoryList?.length ? "col-md-6" : "col-md-10"
                } position-relative`}
              >
                <span
                  style={{ position: "absolute", top: "8px", left: "25px" }}
                >
                  <SearchIcon />
                </span>
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search"
                  onChange={(e) => handleSearch(e)}
                  style={{ paddingLeft: "35px" }}
                  value={searchValue}
                />
              </div>
              <div className=" mr-2 ">
                <ClientCategoryFilter
                  activeStatus={activeStatus}
                  setActiveStatus={setActiveStatus}
                  activeStatusValue={activeStatusValue}
                  setActiveStatusValue={setActiveStatusValue}
                  setClearFilter={setClearFilter}
                  setOffset={setOffset}
                />
              </div>
              {isAddClientCategoryPresent && !!clientCategoryList?.length && (
                <button
                  className="btn btn-primary"
                  onClick={toggleAddEditClientCategoryModal}
                >
                  + Add Client Category
                </button>
              )}
            </div>
          </div>
          <div>
            {fetching && offset == 0 ? (
              <TableLoader Rows={10} ColumnPerRow={7} />
            ) : clientCategoryList?.length > 0 ? (
              <ClientCategoryTable
                data={data}
                handleEditMasterClientCategory={handleEditMasterClientCategory}
                fetching={fetching}
                offset={offset}
                isEditClientCategoryPresent={isEditClientCategoryPresent}
              />
            ) : (
              <div className="mt-5 pb-5">
                {!fetching && data?.length === 0 && (
                  <EmptyListPage
                    title="No Client Category List Found!"
                    image={EmptyList}
                    imageWidth="30%"
                    showAddButton={isAddClientCategoryPresent}
                    buttonTitle="+ Add Client Category"
                    onButtonClick={toggleAddEditClientCategoryModal}
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      {showAddEditClientCategoryModal && (
        <AddEditClientCategory
          showAddEditClientCategoryModal={showAddEditClientCategoryModal}
          toggleAddEditClientCategoryModal={toggleAddEditClientCategoryModal}
          isEdit={isEdit}
          clientCategoryName={clientCategoryName}
          clientCategoryNameError={clientCategoryNameError}
          handleAddClientCategory={handleAddClientCategory}
          handleClientCategoryNameChange={handleClientCategoryNameChange}
          handleToogleStatusChange={handleToogleStatusChange}
          status={status}
          uniqueClientFetching={uniqueClientFetching}
          clientGroupUniqueCheckMessage={clientGroupUniqueCheckMessage}



        />
      )}
      {handleErrorModal()}
      <Toaster />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  fetching: state.masterData.fetching,
  statusCode: state.masterData.statusCode,
  error: state.masterData.error,
  clientCategoryList: state.masterData.clientCategoryList,
  clientCategoryTotalCount: state.masterData.clientCategoryTotalCount,
  success: state.masterData.success,
  message: state.masterData.message,
  clientGroupUniqueCheckMessage: state.masterData.clientGroupUniqueCheckMessage,
  uniqueClientFetching: state.masterData.clientGroupUniqueCheckFetching,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetMasterSuccess: () => dispatch(resetMasterSuccess()),
  dispatchResetMasterError: () => dispatch(resetMasterError()),
  dispatchResetMasterMessage: () => dispatch(resetMasterMessage()),
  dispatchResetClientCategoryList: () => dispatch(resetClientCategoryList()),
  rdispatchResetClientCategoryTotalCount: () =>
    dispatch(resetClientCategoryTotalCount()),
  dispatchResetMasterStatusCode: () => dispatch(resetMasterStatusCode()),
  dispatchGetMasterDataClientCategoryAction: (
    data: GetClientCategoryPayloadType
  ) => dispatch(getMasterDataClientCategoryAction(data)),
  dispatchAddMasterDataClientCategoryAction: (
    data: AddClientCategoryPayloadType
  ) => dispatch(createMasterDataClientCategoryAction(data)),
  dispatchUpdateMasterDataClientCategoryAction: (
    data: UpdateClientCategoryPayloadType
  ) => dispatch(updateMasterDataClientCategoryAction(data)),
  dispatchCheckUniqueClientGroupName: (data: UniqueClientGroupNamePayloadType) => dispatch(checkUniqueClientGroupNameAction(data)),
  dispatchResetClientGroupUniqueCheckMessage: () => dispatch(resetClientGroupUniqueCheckMessage()),
  dispatchResetresetClientGroupUniqueCheckFetching: () => dispatch(resetClientGroupUniqueCheckFetching())

});

export default connect(mapStateToProps, mapDispatchToProps)(ClientCategory);
